/* eslint-disable */
import React, { Component, PropTypes } from 'react';
import { geti18n } from '../../utils';
import {
  PaginatorWrapperStyled,
  PaginatorListStyled,
  PaginatorUiWrapperStyled,
  PaginatorUiButtonWrapperStyled,
  PaginatorUiButtonStyled,
  PaginatorUiIndicatorsWrapperStyled,
  PaginatorUiIndicatorStyled
} from './styles';

class Paginator extends Component {
  static propTypes = {
    prevButtonText: PropTypes.string,
    nextButtonText: PropTypes.string
  };
  static defaultProps = {
    itemsPerList: 1,
    prevButtonText: geti18n('leadsFormContent.paginator.prev'),
    nextButtonText: geti18n('leadsFormContent.paginator.next')
  };
  constructor() {
    super();
    this.state = {
      paginatorCurrentIndex: 0
    };
  }

  uiButtonAction = (buttonName, index) => {
    const { data, itemsPerList } = this.props;
    let paginatorCurrentIndex = this.state.paginatorCurrentIndex;

    if (buttonName === 'prev' && paginatorCurrentIndex > 0) paginatorCurrentIndex = paginatorCurrentIndex - 1;
    if (buttonName === 'next' && paginatorCurrentIndex < data.length / itemsPerList - 1)
      paginatorCurrentIndex = paginatorCurrentIndex + 1;
    if (buttonName === 'indicator' && !isNaN(index)) paginatorCurrentIndex = index / itemsPerList;

    this.setState({
      paginatorCurrentIndex
    });
  };

  renderUiIndicator = () => {
    const { data, itemsPerList, mediaType } = this.props;
    const currentIndex = this.state.paginatorCurrentIndex;
    let count = 1;
    const indicators = data.map((dealer, index) => {
      if (index === 0 || count / itemsPerList === 1) {
        count = 1;
        //Only return current page on small breakpoint
        if (mediaType === 'small') {
          if (index / itemsPerList === currentIndex) {
            return <PaginatorUiIndicatorStyled key={index}>{index / itemsPerList + 1}</PaginatorUiIndicatorStyled>;
          } else {
            return null;
          }
        } else {
          return (
            <PaginatorUiIndicatorStyled
              onClick={() => {
                if (index / itemsPerList !== currentIndex) {
                  this.uiButtonAction('indicator', index);
                }
              }}
              selected={index / itemsPerList === currentIndex ? true : false}
              key={index}
            >
              {index / itemsPerList + 1}
            </PaginatorUiIndicatorStyled>
          );
        }
      } else {
        count++;
        return null;
      }
    });
    return indicators;
  };

  disableUiButton = (buttonName) => {
    const { data, itemsPerList } = this.props;
    const paginatorCurrentIndex = this.state.paginatorCurrentIndex;
    return (buttonName === 'prev' && paginatorCurrentIndex === 0) ||
      (buttonName === 'next' && paginatorCurrentIndex >= data.length / itemsPerList - 1)
      ? true
      : false;
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ paginatorCurrentIndex: 0 });
    }
  }

  render() {
    const { children, data, itemsPerList, prevButtonText, nextButtonText } = this.props;
    const dataBeginSlice = this.state.paginatorCurrentIndex * itemsPerList;
    const dataEndSlice = dataBeginSlice + itemsPerList;
    const dataSliced = data.slice(dataBeginSlice, dataEndSlice);
    const childrenWithProps = React.Children.map(children, (child) => React.cloneElement(child, { data: dataSliced }));
    return (
      <PaginatorWrapperStyled>
        <PaginatorListStyled>{childrenWithProps}</PaginatorListStyled>
        <PaginatorUiWrapperStyled>
          <PaginatorUiButtonWrapperStyled>
            <PaginatorUiButtonStyled
              onClick={() => {
                if (!this.disableUiButton('prev')) {
                  this.uiButtonAction('prev');
                }
              }}
              disabled={this.disableUiButton('prev')}
              prev
            >
              {prevButtonText}
            </PaginatorUiButtonStyled>
          </PaginatorUiButtonWrapperStyled>

          <PaginatorUiIndicatorsWrapperStyled>{this.renderUiIndicator()}</PaginatorUiIndicatorsWrapperStyled>

          <PaginatorUiButtonWrapperStyled>
            <PaginatorUiButtonStyled
              onClick={() => {
                if (!this.disableUiButton('next')) {
                  this.uiButtonAction('next');
                }
              }}
              disabled={this.disableUiButton('next')}
              next
            >
              {nextButtonText}
            </PaginatorUiButtonStyled>
          </PaginatorUiButtonWrapperStyled>
        </PaginatorUiWrapperStyled>
      </PaginatorWrapperStyled>
    );
  }
}

export default Paginator;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/Paginator/index.js
 **/